module.exports = __webpack_public_path__ + "static/media/Anuj_sir_review.e3798fa8.mp4";